/* SerranoMarkt | BTS second-box core | QA only */
(() => {
  'use strict';
  const B = window.SerranoBtsSecondBox = window.SerranoBtsSecondBox || {};
  if (B.coreReady) return;
  B.coreReady = true;
  B.title = 'BACK TO SCHOOL | 2. Kutu %50';
  B.trackEvent = 'Daily Nuuds BTS Two Boxes Added';
  B.uid = B.uid || 0;

  B.numericId = (value) => {
    const match = String(value || '').match(/(\d+)$/);
    return match ? Number(match[1]) : null;
  };
  B.number = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  };
  B.formatTry = (cents, maximumFractionDigits = 2) => {
    const amount = B.number(cents) / 100;
    return `${new Intl.NumberFormat('tr-TR', {
      minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
      maximumFractionDigits
    }).format(amount)} TL`;
  };
  B.discountedUnitText = (price, pack) => {
    const safePack = B.number(pack);
    if (!safePack || !B.number(price)) return '';
    return `${B.formatTry((B.number(price) * 0.5) / safePack)}/adet`;
  };
  B.estimatedPairTotal = (firstPrice, secondPrice) => {
    const first = B.number(firstPrice);
    const second = B.number(secondPrice);
    return first && second ? first + second - Math.min(first, second) * 0.5 : 0;
  };
  B.sourceName = () => window.SerranoBuilderSource?.resolve?.() || 'Kutu oluşturucu';
  B.scrollTo = (element) => {
    if (!element) return;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      element.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'center',
        inline: 'nearest'
      });
    }));
  };
  B.track = (payload) => {
    window._learnq = window._learnq || [];
    window._learnq.push(['track', B.trackEvent, payload]);
  };
  B.setBusy = (button, busy, label) => {
    if (!button) return;
    if (!button.dataset.bts2OriginalHtml) button.dataset.bts2OriginalHtml = button.innerHTML;
    button.disabled = Boolean(busy);
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
    if (busy && label) {
      const title = button.querySelector('[data-bts2-title], strong');
      if (title) title.textContent = label;
    } else if (!busy && button.dataset.bts2OriginalHtml) {
      button.innerHTML = button.dataset.bts2OriginalHtml;
    }
  };
  B.addItems = async ({ items, button, errorNode, tracking }) => {
    if (!Array.isArray(items) || items.length !== 2 || items.some((item) => !item?.id)) {
      if (errorNode) errorNode.textContent = 'Kutu seçimlerinden biri doğrulanamadı. Lütfen tekrar dene.';
      return;
    }
    if (errorNode) errorNode.textContent = '';
    B.setBusy(button, true, 'İKİ KUTU SEPETE EKLENİYOR…');
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items })
      });
      const payload = await response.json();
      if (!response.ok || payload?.status) throw new Error(payload?.description || payload?.message || 'İki kutu sepete eklenemedi.');
      B.track({
        campaign: B.title,
        pair_mode: tracking?.mode || '',
        first_pack: tracking?.firstPack || '',
        second_pack: tracking?.secondPack || '',
        estimated_campaign_total: tracking?.estimatedTotal || '',
        page_url: window.location.href
      });
      window.location.assign('/cart');
    } catch (error) {
      const rawMessage = error?.message || 'İki kutu sepete eklenemedi.';
      const isStockError = /tükendi|stok|stock|sold out|not enough/i.test(rawMessage);
      let shopperMessage = rawMessage;
      if (isStockError && (tracking?.mode === 'same_colours' || tracking?.mode === 'ready_same')) {
        shopperMessage = 'Aynı kutudan ikinci kez eklemek için yeterli stok yok. 2. kutunun renklerini farklı seçebilirsin.';
      } else if (isStockError) {
        shopperMessage = 'Seçtiğin kutulardan birinde yeterli stok yok. 2. kutunun renklerini değiştirip tekrar dene.';
      }
      if (errorNode) errorNode.textContent = shopperMessage;
      B.setBusy(button, false);
    }
  };

  B.signature = (builder) => [builder?.pack, builder?.productKey?.(), builder?.variantTitle?.(), builder?.selectionDetails?.()].join('::');
  B.snapshot = (builder) => {
    const variant = builder?.selectedVariant?.();
    const product = builder?.products?.[builder?.productKey?.()] || {};
    const pack = B.number(builder?.pack);
    const price = B.number(product.price);
    const variantId = B.numericId(variant?.id);
    if (!builder?.ready || !variantId || !pack || !price) return null;
    return {
      variantId, pack, price,
      title: product.title || `${pack}'li Daily Nuuds kutusu`,
      handle: product.handle || '',
      variantTitle: builder.variantTitle?.() || '',
      cutSummary: builder.cutSummary?.() || '',
      selectionDetails: builder.selectionDetails?.() || '',
      signature: B.signature(builder)
    };
  };
  B.builderLine = (snapshot, order) => ({
    id: snapshot.variantId,
    quantity: 1,
    properties: {
      '_Paket Tipi': `KUTU - ${snapshot.pack}'li`,
      '_Kutu İçeriği': snapshot.variantTitle,
      '_Kesim Dağılımı': snapshot.cutSummary,
      '_Seçimler': snapshot.selectionDetails,
      '_Bundle Parent': snapshot.handle,
      'image-swatches-1': snapshot.variantTitle,
      '_Kaynak': B.sourceName(),
      '_BTS Kampanya': B.title,
      '_BTS Kutu Sırası': `${order}/2`
    }
  });
  B.readyLine = (seed, order) => ({
    id: seed.variantId,
    quantity: 1,
    properties: { '_Kaynak': 'Ürün sayfası hazır kutu', '_BTS Kampanya': B.title, '_BTS Kutu Sırası': `${order}/2` }
  });
  B.remapIds = (root, suffix) => {
    const map = new Map();
    if (root.id) { const old = root.id; root.id = `${old}-${suffix}`; map.set(old, root.id); }
    root.querySelectorAll('[id]').forEach((element) => {
      const old = element.id;
      if (!old) return;
      element.id = `${old}-${suffix}`;
      map.set(old, element.id);
    });
    ['for', 'aria-labelledby', 'aria-describedby', 'aria-controls'].forEach((attribute) => {
      root.querySelectorAll(`[${attribute}]`).forEach((element) => {
        const value = element.getAttribute(attribute);
        if (value) element.setAttribute(attribute, value.split(/\s+/).map((token) => map.get(token) || token).join(' '));
      });
    });
  };
})();
